export default __webpack_public_path__ + "static/Iveco Daily-b0b61b919321b9ef3ef652f616465f74.jpg";